import {
  fetchAllCategories,
  selectCustomerBulkOutcomes,
  selectFromCustomerBulkOutcomes,
  selectUseCaseBulkOutcomes,
} from 'actions';
import Navbar from 'components/Navbar';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getUserCustomer } from 'selectors/auth';
import { getModel } from 'selectors/models';
import { getNavParams } from 'selectors/nav';
import { useSelector } from 'store';
import { NAV_BAR_HEIGHT_REM } from 'utils/dimensions';
import BulkOutcomesHeader from './BulkOutcomesHeader';
import RulesList from './RulesList';

type RouteParams = {
  modelId: string;
};

const BulkOutcomesPage: React.VFC = () => {
  const dispatch = useDispatch();
  const { modelId } = useParams<RouteParams>();

  const ruleIds = useSelector(getNavParams).rule_uuids as string[];
  const fromCustomer = useSelector(getNavParams).from_customer as string;

  const customer = useSelector(getUserCustomer);
  const model = useSelector(getModel(modelId));

  useEffect(() => {
    if (customer && customer.uuid) {
      dispatch(
        fetchAllCategories({
          model_uuids: [modelId],
          rule_uuids: ruleIds || [],
          include_staging: 'true',
          relationships: ['rule_head.rule_group', 'model', 'outcome'],
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, customer?.uuid, ruleIds]);

  useEffect(() => {
    if (customer) {
      dispatch(selectCustomerBulkOutcomes(customer));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (fromCustomer) {
      dispatch(selectFromCustomerBulkOutcomes(fromCustomer));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, fromCustomer]);

  useEffect(() => {
    if (model) {
      dispatch(selectUseCaseBulkOutcomes(model));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, customer?.uuid, model]);

  const warningBarOffset =
    document != null &&
    document.getElementById != null &&
    document.getElementById('customer-warning')?.offsetHeight;

  return (
    <div
      className="min-w-screen bg-white"
      style={{
        height: `calc(100vh - ${warningBarOffset}px)`,
      }}
    >
      <Navbar />
      <div
        className="flex flex-row w-full"
        style={{
          height: `calc(100vh - ${warningBarOffset}px - ${NAV_BAR_HEIGHT_REM}rem)`,
        }}
      >
        <div className="h-full flex flex-col overflow-hidden w-full">
          <BulkOutcomesHeader />

          <main className="h-full flex w-full overflow-auto custom-scrollbar p-4">
            <RulesList />
          </main>
        </div>
      </div>
    </div>
  );
};

export default BulkOutcomesPage;
